/**
 * Created by XBindt on 14-5-2014.
 */
if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Toggle edit form
         * Toggle form open/close to edit input data (replaces previously used Form Edit functionality)
         */
        ZZ.FormsToggle = function(container) {
            var base = this;

            base.container = container;
            base.items = [];
            base.initItems = [];
            base.assignListeners();
        };

        ZZ.FormsToggle.prototype = {
            assignListeners: function() {
                var base = this,
                    i,
                    length,
                    items,
                    item;

                items = base.container.find("form");

                for (i = 0, length = items.length; i < length; i++) {
                    item = new ZZ.FormsToggleItem($(items[i]));
                    base.items.push(item);
                    item.container.bind("edit", this.edit.bind(base, item));
                    item.container.bind(
                        "ZZ-cancel-edit-toggle-item",
                        this.cancelEdit.bind(base, item)
                    );
                }
            },

            edit: function(item, event) {
                var i,
                    length,
                    toggleItem,
                    cancelEdit = false;

                for (i = 0, length = this.items.length; i < length; i++) {
                    toggleItem = this.items[i];
                    cancelEdit = toggleItem.inEditmodus;

                    if (cancelEdit) {
                        break;
                    }
                    toggleItem.close();
                }

                toggleItem = item;
                if (!cancelEdit) {
                    toggleItem.open();
                } else {
                    toggleItem.openFailed();
                }
            },

            cancelEdit: function(item, event) {
                var toggleItem = item;
                toggleItem.close();
                item.container.trigger("ZZ-cancel-edit-toggle");
                item.container
                    .get(0)
                    .dispatchEvent(new CustomEvent("ZZ-cancel-edit-toggle"));
            }
        };
    })(jQuery);
}
